'use client'

import React from 'react'

import { Footer, Header, PageWrapper } from 'Components/Blocks'
import Posts from 'Components/Pages/_Legacy/Blog/posts'
import { Column, Row } from 'Components/UI'

import { BlogRecordFragment } from 'GraphQL/DatoCMS/TypedDocuments'

import Hero from './hero'

type Props = {
  heroPost?: BlogRecordFragment
  page?: number
  posts?: BlogRecordFragment[]
  totalPages?: number
}

function BlogPage({ heroPost, page = 1, posts, totalPages = 1 }: Props) {
  return (
    <PageWrapper>
      <Header />

      <Column alignCenter as="main" fullWidth overflowX="hidden">
        <Row height={[76, 76, 92]} />

        {heroPost && <Hero data={heroPost} />}

        <Posts data={posts} page={page} totalPages={totalPages} />
      </Column>

      <Footer />
    </PageWrapper>
  )
}

export default BlogPage
